import React from 'react';
import { translate } from '../../../../../../../utils/translation/translation';
import MenuItem from '../../MenuItem/MenuItem';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { translationsState } from '../../../../../../../atoms/translation/translation.atom';
import EditIcon from '@mui/icons-material/Edit';
import { highlightedRowState } from '../../../../../../../atoms/layout/layout.atom';
import { roleAccessState } from '../../../../../../../atoms/auth/auth.atom';
import { hasRoleAccess } from '../../../../../../../utils/access/access';
import { HttpMethod } from '../../../../../../../domain/Role';
import { useLinkGeneration } from '../../../../../../../hooks/useLinkGeneration/useLinkGeneration';
import { ParentObjectType } from '../../../../../../List/List.helpers';

export type EditActionProps = {
  to: string;
  itemId?: string;
  onSuccess?: () => void;
  baseApiUrl?: string;
  includeRedirect?: boolean;
  parentObject?: ParentObjectType;
};

export const EditAction = ({
  to,
  itemId,
  onSuccess,
  baseApiUrl,
  includeRedirect,
  parentObject,
}: EditActionProps) => {
  const translations = useRecoilValue(translationsState);
  const setHighlightedRowState = useSetRecoilState(highlightedRowState);
  const roleAccessValue = useRecoilValue(roleAccessState);
  const navigate = useNavigate();

  const link = useLinkGeneration(to, parentObject, includeRedirect);

  const handleClick = (e: any) => {
    e.stopPropagation();
    setHighlightedRowState(itemId ?? null);
    navigate(link);
    onSuccess?.();
  };

  return (
    <MenuItem
      onClick={handleClick}
      disabled={
        !hasRoleAccess(roleAccessValue, HttpMethod.PATCH, `${baseApiUrl}/:id`)
      }
    >
      <EditIcon width={20} height={20} />
      {translate(translations, 'ROW_ACTION.EDIT')}
    </MenuItem>
  );
};

export default EditAction;
